import { getPlanSponsorDetailsCtor, axiosInstance as restInstance } from '@/lib/sponsors/planSponsorGetDetails';
import { planSponsorCreatePlanCtor } from '@/lib/sponsors/planSponsorCreatePlan';
import { getPlanSponsorEmployeeListCtor } from '@/lib/sponsors/planSponsorGetEmployeeList'
import { camelify } from '@/helpers/case';

export default {
  state: {
    planDetails: {},
    loadingPlan: true,
    addingPlan: true,
    loadingPlanEmployees: true,
    planEmployees: [],
    loadingAllPlanEmployees: true,
    allPlanEmployees: [],
  },
  getters: {
    plans(state) {
      return state;
    },
    isLoadingPlan(state) {
      return state.loadingPlan;
    },
    planDetails(state) {
      return state.planDetails;
    },
    addingPlan(state) {
      return state.addingPlan;
    },
    loadingPlanEmployees(state) {
      return state.loadingPlanEmployees;
    },
    planEmployees(state) {
      return state.planEmployees;
    },
    loadingAllPlanEmployees(state) {
      return state.loadingAllPlanEmployees;
    },
    allPlanEmployees(state) {
      return state.allPlanEmployees;
    }
  },
  mutations: {
    updatePlans(state, plans) {
      Object.assign(state, plans);
    },
    setLoadingPlan(state, loadingPlan) {
      state.loadingPlan = loadingPlan;
    },
    updatePlanDetails(state, planDetails) {
      state.planDetails = planDetails;
    },
    setAddingPlan(state, addingPlan) {
      state.addingPlan = addingPlan;
    },
    setLoadingPlanEmployees(state, loadingPlanEmployees) {
      state.loadingPlanEmployees = loadingPlanEmployees;
    },
    setPlanEmployees(state, planEmployees) {
      state.planEmployees = planEmployees;
    },
    setLoadingAllPlanEmployees(state, loadingAllPlanEmployees) {
      state.loadingAllPlanEmployees = loadingAllPlanEmployees;
    },
    setAllPlanEmployees(state, allPlanEmployees) {
      state.allPlanEmployees = allPlanEmployees;
    },
  },
  actions: {
    updatePlans({ commit }, plan) {
      commit('updatePlans', plan);
    },
    async fetchPlanDetails({ commit, rootGetters }, { routeId, planId }) {
      commit('setLoadingPlan', true);
      try {
        const axiosInstance = await restInstance(rootGetters?.ciToken || null);
        const planSponsorGetDetails = getPlanSponsorDetailsCtor({ axiosInstance });
        let sponsorDetails;
        if(planSponsorGetDetails) {
          sponsorDetails = await planSponsorGetDetails(routeId);
        }
        let plan;
        if(sponsorDetails?.plans && sponsorDetails?.plans?.length) {
          plan = sponsorDetails.plans.filter(((thisPlan) => thisPlan.id === planId));
          commit('updatePlanDetails', plan[0]);
          commit('setLoadingPlan', false);
          return plan[0];
        }
        return {};
      } catch(e) {
        commit('setLoadingPlan', false);
        return Promise.reject(e);
      }
    },
    async addPlan({ commit, rootGetters }, { id, data }) {
      commit('setAddingPlan', true);
      try {
        const axiosInstance = await restInstance(rootGetters?.ciToken || null);
        const planSponsorCreatePlan = planSponsorCreatePlanCtor({ axiosInstance });
        let plan;
        if(planSponsorCreatePlan) {
          plan = await planSponsorCreatePlan(id, data);
          commit('setAddingPlan', false);
          return plan;
        }
        return false;
      } catch(e) {
        commit('setAddingPlan', false);
        return Promise.reject(e);
      }
    },
    async fetchPlanEmployees({ commit, rootGetters }, planId) {
      commit('setLoadingPlanEmployees', true);
      commit('setPlanEmployees', []);
      try {
        const axiosInstance = await restInstance(rootGetters?.ciToken || null);
        const getPlanSponsorEmployeeList = getPlanSponsorEmployeeListCtor({ axiosInstance });
        let employees;
        if(getPlanSponsorEmployeeList) {
          employees = await getPlanSponsorEmployeeList(planId);
          commit('setPlanEmployees', employees);
        }
        commit('setLoadingPlanEmployees', false);
        return employees;
      } catch(e) {
        commit('setLoadingPlanEmployees', false);
        return Promise.reject(e);
      }
    },
    async fetchAllPlanEmployees({ commit, rootGetters }, planIdsArray) {
      commit('setAllPlanEmployees', []);
      commit('setLoadingAllPlanEmployees', true);
      try {
        const axiosInstance = await restInstance(rootGetters?.ciToken || null);
        const getPlanSponsorEmployeeList = getPlanSponsorEmployeeListCtor({ axiosInstance });
        if(getPlanSponsorEmployeeList) {
          let allPlanEmployees = [];
          await Promise.allSettled(planIdsArray.map(async (id) => {
            const result = await getPlanSponsorEmployeeList(id);
            allPlanEmployees.push(...camelify(result));
          }));          
          commit('setAllPlanEmployees', allPlanEmployees);
          commit('setLoadingAllPlanEmployees', false);
          return allPlanEmployees;
        }
      } catch(e) {
        commit('setLoadingAllPlanEmployees', false);
        return Promise.reject(e);
      }
    },
  },
};
